import { SelectedAgent } from '@/features/ai-agents/shared/models';
import { capitalize } from '@/utils/types';
import {
  AgentMetadata,
  ModelProvider,
} from '@/features/ai-agents/components/agent-selection-dropdown';

export function getAgentDetails(selectedAgent: SelectedAgent): AgentMetadata {
  const isGoogleGemini = selectedAgent?.id?.includes(
    ModelProvider.GOOGLE_GEMINI.toString(),
  );
  const isOpenAiGpt = selectedAgent?.id?.includes(
    ModelProvider.OPENAI_GPT.toString(),
  );
  const isAnthropicClaude = selectedAgent?.id?.includes(
    ModelProvider.ANTHROPIC_CLAUDE.toString(),
  );

  let modelProvider: ModelProvider;

  if (isGoogleGemini) {
    modelProvider = ModelProvider.GOOGLE_GEMINI;
  } else if (isOpenAiGpt) {
    modelProvider = ModelProvider.OPENAI_GPT;
  } else if (isAnthropicClaude) {
    modelProvider = ModelProvider.ANTHROPIC_CLAUDE;
  } else {
    modelProvider = ModelProvider.UNKNOWN;
  }

  let modelType: string = trimPrefixSuffix(
    selectedAgent?.id?.split(modelProvider.toString())?.[1] || ``,
    `-`,
  );

  let fullModelName: string;
  fullModelName = modelProvider.toString();
  if (modelType) {
    fullModelName += `-${modelType}`;
  }

  let businessId: string;
  if (modelProvider === ModelProvider.UNKNOWN) {
    businessId = selectedAgent?.id || `Custom Agent`;
  } else {
    businessId = trimPrefixSuffix(
      selectedAgent?.id?.split(modelProvider.toString())?.[0],
      `-`,
    );
  }

  const businessName: string = capitalize(businessId.replaceAll(`-`, ` `));

  if (selectedAgent?.id === `widget-developer`) {
    modelProvider = ModelProvider.VERCEL_V0;
    modelType = `1.5-md`;
    fullModelName = `vercel-v0-1.5-md`;
  }

  if (selectedAgent?.id === `section-modifier`) {
    modelProvider = ModelProvider.GOOGLE_GEMINI;
    modelType = `3.1-pro-preview`;
    fullModelName = `gemini-3.1-pro-preview`;
  }

  const businessModelName = capitalize(
    fullModelName.replaceAll(`sonnet-4-`, `sonnet-4.`).replaceAll(`-`, ` `),
  );

  return {
    id: selectedAgent?.id || ``,
    type: selectedAgent?.type || ``,
    modelProvider,
    modelType,
    fullModelName,
    businessId,
    businessName,
    businessModelName,
    isDevModel: selectedAgent?.id?.includes(`dev`),
  } as AgentMetadata;
}

function trimPrefixSuffix(str: string, char: string): string {
  if (str.startsWith(char)) {
    str = str.slice(1);
  }
  if (str.endsWith(char)) {
    str = str.slice(0, -1);
  }
  return str;
}
